export const generic_errors = {
    'es':{
        INCOMPLETE_FORM:'Llene los campos faltantes'
    },
    'eng':{
        INCOMPLETE_FORM:'Fill in the missing fields'
    }
    
}